<div id="serviceSelection" *ngIf="config" class="container">
	<form #form="ngForm">
		<div class="row">
			<div class="col">{{'SELECT_OTP' | translate}}</div>
		</div>
		<div class="row">
			<div class="col-2 mb-3">
				<div class="form-check">
					<input class="form-check-input" type="radio" id="otpDeliverySms" name="otpMethod" [(ngModel)]="otpMethod" value="sms" (change)="onOtpMethodChange()">
					<label class="form-check-label" for="otpDeliverySms">{{ 'OTP_SMS' | translate }}</label>
				</div>
			</div>
			<div class="col-2 mb-3">
				<div class="form-check">
					<input class="form-check-input" type="radio" id="otpDeliveryEmail" name="otpMethod" [(ngModel)]="otpMethod" value="email" (change)="onOtpMethodChange()">
					<label class="form-check-label" for="otpDeliveryEmail">{{ 'OTP_EMAIL' | translate }}</label>
				</div>
			</div>
		</div>
		<div class="row" *ngIf="otpMethod === 'email'">
			<div class="col mb-3">
				<div class="form-floating">
					<input type="text" class="form-control" id="emailInput" name="email" type="email" [(ngModel)]="email" maxlength="50" required>
					<label for="emailInput">{{ 'OTP_EMAIL' | translate }}</label>
				</div>
			</div>
		</div>
		<div class="row" *ngIf="otpMethod === 'sms'">
			<div class="col mb-3">
				<div class="form-floating">
					<input type="text" class="form-control" id="msisdnInput" name="msisdn" [(ngModel)]="msisdn" maxlength="9"  required>
					<label for="msisdnInput">{{ 'MOBILE_NUMBER' | translate }}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" *ngIf="!dontHaveId">
				<div class="form-floating">
					<select class="form-select" id="idTypeInput" name="idType" [(ngModel)]="idType" [disabled]="dontHaveId" required>
						<option *ngFor="let idType of idTypeList" [ngValue]="idType">{{idType.value}}</option>
					</select>
					<label for="idTypeInput">{{ 'ID_TYPE' | translate }}</label>
				</div>
			</div>
			<div class="col mb-3">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="haveIdInput" name="haveId" [(ngModel)]="dontHaveId" (change)="onDontHaveIdChange()">
					<label class="form-check-label" for="haveIdInput">{{ 'DONT_HAVE_ID' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" *ngIf="!dontHaveId">
				<div class="form-floating">
					<input type="text" class="form-control" id="idInput" name="idNumber" #idNumberRef="ngModel" [pattern]="idType?.regex" [(ngModel)]="idNumber" [maxlength]="idType?.maxLength" [readOnly]="dontHaveId" required>
					<label for="idInput">{{ 'ID_NUMBER' | translate }}</label>
					<div class="error-msg" *ngIf="idNumberRef.invalid && idNumberRef.touched">
						{{idType?.desc}}
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" id="preregisteredInput" name="preregistered" [(ngModel)]="preregistered" (change)="onPreregistered()" disabled>
					<label class="form-check-label" for="preregisteredInput">{{ 'PREREGISTERED' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="nameInput" name="name" #nameRef="ngModel" [(ngModel)]="name" maxlength="50" [disabled]="nameDisabled" required>
					<label for="nameInput">{{ 'NAME' | translate}}</label>
					<div class="error-msg" *ngIf="nameRef.invalid && nameRef.touched">
						{{ 'NAME' | translate}} is required
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="surnameInput" name="surname" #surnameRef="ngModel" [(ngModel)]="surname" maxlength="50" [disabled]="surnameDisabled" required>
					<label for="surnameInput">{{ 'SURNAME' | translate}}</label>
					<div class="error-msg" *ngIf="surnameRef.invalid && surnameRef.touched">
						{{ 'SURNAME' | translate}} is required
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<select class="form-select" id="genderInput" name="gender" #genderRef="ngModel" [(ngModel)]="gender" required>
						<option *ngFor="let gender of genderList" [ngValue]="gender">{{gender}}</option>
					</select>
					<label for="genderInput">{{ 'GENDER' | translate }}</label>
					<div class="error-msg" *ngIf="genderRef.invalid && genderRef.touched">
						{{ 'GENDER' | translate }} is required
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input
						class="form-control"
						name="dp"
						ngbDatepicker #d="ngbDatepicker"
						(click)="d.toggle()"
						id="dobInput"
						name="dob"
						[startDate]="startDate"
						[minDate]="minDob"
						[maxDate]="maxDob"
						[(ngModel)]="dateOfBirth"
						#dobRef="ngModel"
						required>
					<label for="dobInput">{{ 'DOB' | translate}}</label>
					<div class="error-msg" *ngIf="dobRef.invalid && dobRef.touched">
						{{ 'DOB' | translate}} is required
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="provinceInput" name="province" [(ngModel)]="province" disabled="true" required>
					<label for="provinceInput">{{ 'PROVINCE' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="municipalityInput" name="municipality" [(ngModel)]="municipality" disabled="true" required>
					<label for="municipalityInput">{{ 'MUNICIPALITY' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="communeInput" name="commune" [(ngModel)]="commune" disabled="true" required>
					<label for="communeInput">{{ 'COMMUNE' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col mb-3" >
				<div class="form-floating">
					<input type="text" class="form-control" id="capInput" name="cap" [(ngModel)]="cap" disabled="true" required>
					<label for="capInput">{{ 'CAP' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="row button-row">
			<div class="col text-end">
				<button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="!form.valid">{{ 'NEXT' | translate}}</button>
			</div>
		</div>
	</form>
</div>
